import { ExtensionInstructionsCard } from "@components/Cards";
import { Modal } from "@design-system/Modal/Modal";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  clientId: string;
};

export const ExtensionInstructionsModal = ({
  isOpen,
  onClose,
  clientId,
}: Props) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      placeItems="center"
      transitionDirection="bottom"
    >
      <ExtensionInstructionsCard clientId={clientId} />
    </Modal>
  );
};
